import { render, staticRenderFns } from "./AlfRequestList.vue?vue&type=template&id=32761bff"
import script from "./AlfRequestList.vue?vue&type=script&lang=js"
export * from "./AlfRequestList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports